import { render, staticRenderFns } from "./ChinaMergerView.vue?vue&type=template&id=959f7d84&scoped=true"
import script from "./ChinaMergerView.vue?vue&type=script&lang=js"
export * from "./ChinaMergerView.vue?vue&type=script&lang=js"
import style0 from "./ChinaMergerView.vue?vue&type=style&index=0&id=959f7d84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959f7d84",
  null
  
)

export default component.exports